import "./App.css";
import LandingSection from "./components/LandingSection";
import ParticlesCanvas from "./components/layout/ParticlesCanvas";

function App() {
  return (
    <div className="App">
      <a href="#main-content" className="skip-nav">
        Skip to main content
      </a>
      <main id="main-content">
        <LandingSection />
      </main>
      <ParticlesCanvas />
    </div>
  );
}

export default App;
